import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import {
  type InventoryReportSearch,
  inventoryReportSearchFrom,
} from '@/features/inventory-analysis/api'
import { NoSalesReportScreen } from '@/features/inventory-analysis/no-sales-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/reports/no-sales')({
  validateSearch: (search: Record<string, unknown>): InventoryReportSearch =>
    inventoryReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'inventory_report.view'))
      throw redirect({ to: '/inventory' })
  },
  component: NoSalesReportRoute,
})

function NoSalesReportRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <NoSalesReportScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/inventory/reports/no-sales', search: next })}
    />
  )
}
